// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"361decb0","350":"57e402f3","453":"9cd3def4","732":"d6300edd","960":"23b29811"}[chunkId] + ".chunk.js";
};